import * as React from "react";
import { Spin } from "antd";

const Loader = ({
  children,
  loading = false,
  tip,
  translate,
  size
}: {
  children: any;
  loading: boolean;
  tip?: string;
  translate: any;
  size?: "small" | "default" | "large";
}) => (
  <Spin size={size} spinning={loading} tip={tip}>
    {children}
  </Spin>
);

export default Loader;
